<template>
  <div>
    <div v-if="alerts === 'success'">
      <div
        id="successAlert"
        v-if="display"
        class="alert alert-success alert-dismissible fade in"
        role="alert"
      >
        <button
          @click="closeAlert"
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
        <font-awesome-icon icon="check-circle" />&nbsp;<strong>{{
          title
        }}</strong
        >{{ successMessage }}
      </div>
    </div>
    <div v-else>
      <div
        id="successAlert"
        v-if="display"
        class="alert alert-danger alert-dismissible fade in"
        role="alert"
      >
        <button
          @click="closeAlert"
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
        <div style="margin-bottom: 10px">
          <font-awesome-icon icon="exclamation-circle" />&nbsp;<strong>{{
            title
          }}</strong
          >{{ errorMessage }}
        </div>
        <div v-for="(error, key, index) in errors" :key="index">
          <span v-for="(message, key2, index2) in error" :key="index2">
            {{ message }}<br />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'title',
    'successMessage',
    'errorMessage',
    'alerts',
    'errors',
    'display',
  ],
  data() {
    return {}
  },
  methods: {
    closeAlert: function() {
      this.$emit('closeAlert')
    },
  },
}
</script>
